import React from "react";

import { DeviceDetector } from "@utils";
import classNames from "classnames";

import { isOverlayMode } from "../config/LiveStreamConfig";
import { enterNativeFullscreen, useVideoElement } from "./useVideoElement";

export function PlayPauseButton(props: {
	playerId: string;
	pausedStatus: boolean;
	setPausedState: (paused: boolean) => void;
	onExpand?: () => void;
	isOverlayOpen?: boolean;
}) {
	const { playerId, pausedStatus, setPausedState, onExpand, isOverlayOpen } =
		props;
	const getVideo = useVideoElement(playerId);

	const togglePlayPause = () => {
		const video = getVideo();
		if (pausedStatus) {
			video?.play()?.catch(() => {});
			setPausedState(false);
			if (isOverlayMode()) {
				if (!isOverlayOpen && onExpand) {
					onExpand();
				}
			} else {
				enterNativeFullscreen(video);
			}
		} else {
			video?.pause();
			setPausedState(true);
		}
	};

	const playPauseBtnClasses = classNames("widget__btn btn btn--square", {
		"btn--square--xsml": !DeviceDetector.isMobileTheme,
		"btn--square--sml  btn--secondary widget--ls__btn":
			DeviceDetector.isMobileTheme,
	});

	const playPauseIconClasses = classNames("widget__btn__icon u-icon", {
		"u-icon--tny": !DeviceDetector.isMobileTheme,
		"u-icon--sml": DeviceDetector.isMobileTheme,
		"u-icon--video-play": pausedStatus,
		"u-icon--video-pause": !pausedStatus,
	});

	return (
		<button
			type="button"
			className={playPauseBtnClasses}
			onClick={() => {
				togglePlayPause();
			}}
		>
			<i className={playPauseIconClasses} />
		</button>
	);
}
